import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { targetUserSelector } from '../../../redux/context/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
});

const mapDispatchToProps = {};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ intl: { formatMessage } }) => ({ formatMessage })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/TeamProfile/enhance.js